import React from 'react';
import { useIntl } from 'react-intl';

import { Typography } from 'app/shared/components/atoms';
import { Modal, ModalProps } from 'app/shared/components/molecules';

interface Props extends ModalProps {
  confirmationAction: () => void;
  cancellationAction?: () => void;
  'data-qaid': string;
}

export const VisaBenefitRemovalConfirmationModal: React.FC<
  React.PropsWithChildren<Props>
> = ({
  isOpen,
  setIsOpen,
  confirmationAction,
  cancellationAction,
  'data-qaid': dataQaid,
  ...props
}) => {
  const { formatMessage } = useIntl();

  const title = formatMessage({
    id: 'event.visaBenefitRemovalConfirmationModal.title',
  });
  const description = formatMessage({
    id: 'event.visaBenefitRemovalConfirmationModal.description',
  });
  const confirmationButtonText = formatMessage({
    id: 'event.visaBenefitRemovalConfirmationModal.confirmationButtonText',
  });
  const cancellationButtonText = formatMessage({
    id: 'event.visaBenefitRemovalConfirmationModal.cancellationButtonText',
  });
  const detailText = formatMessage({
    id: 'event.visaBenefitRemovalConfirmationModal.detailText',
  });

  return (
    <Modal
      data-qaid={dataQaid}
      closeOnOutsideClick={true}
      isFullscreenMobile={false}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={title}
      primaryCtaText={confirmationButtonText}
      onClickPrimaryCta={() => {
        confirmationAction();
        setIsOpen(false);
      }}
      secondaryCtaText={cancellationButtonText}
      onClickSecondaryCta={() => {
        cancellationAction && cancellationAction();
        setIsOpen(false);
      }}
      detailText={detailText}
      mobileFlexDirection="column"
      maxWidth="650px"
      {...props}
    >
      <Typography fontSize="fontSize100" fontWeight="regular">
        {description}
      </Typography>
    </Modal>
  );
};
